import axios from 'axios';
import { SERVER_URL } from "../../utils/Constants";
import { LOADING, LOAD_CRON_JOB_BY_TIME_SUCCESS } from "../types";
import MessageUtils from "../../utils/MessageUtils";
import * as i18n from "i18next";


export const getCronJobByTime = () => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        const url = `${SERVER_URL}/system/cron-job`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } }

        axios.get(url, header)
            .then(response => getCronJobByTimeSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:manualActions.loadCronJobsFailure')));
    }
}

const getCronJobByTimeSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_CRON_JOB_BY_TIME_SUCCESS, payload: response.data });
}

export const triggeringCronJobAction = (actionId, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        const url = `${SERVER_URL}/system/cron-job?actionId=${actionId}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token ? getState().user.token : localStorage.getItem('token')}` } };

        if (callback) {
            callback()
        }

        axios.put(url, {}, header)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
            })
            .catch(error => {
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure'));
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/systemControl/ManualActions.js